var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeVerticalLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 50,
    viewBox: "0 0 2 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 50,
    rx: 1,
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeVerticalLine);
export default __webpack_public_path__ + "static/media/orange-vertical-line.4a7a2e5ab6ac00e5d195bf527950fb9b.svg";
export { ForwardRef as ReactComponent };